class StorageTransformer {
  public static getStringFromMap(storageMap: Map<string, string>, separator: string): string {
    const values = new Array<string>();
    storageMap.forEach((value, key) => {
      values.push(`${key}=${value}`);
    });
    return values.join(separator);
  }

  public static getMapFromString(payload: string, separator: string): Map<string, string> {
    if (payload.length <= 0) {
      return new Map<string, string>();
    }

    return payload.split(separator).reduce((acc, attr) => {
      const [key, value] = attr.split('=');
      acc.set(key, value);
      return acc;
    }, new Map<string, string>());
  }
}

export default StorageTransformer;
